import {Property} from 'csstype';
import {Int} from '@store/@types/util';

const COLORS: Property.Color[] = ['#3A84AD', '#DC8E46', '#60895D', '#8A489A', '#b28704'];
const NINE_BOX_COLORS = [
  '#44C1BA',
  '#B3E6CE',
  '#5EC95E',
  '#BFC757',
  '#2D6486',
  '#C26647',
  '#4B3EBB',
  '#C14C44',
  '#502B1B',
  '#D788D2',
  '#174525',
  '#CB7062',
  '#2B7882',
] as const;

export const skillColorByIdx = (index: Int): Property.Color => {
  return COLORS[index % COLORS.length];
};

export function skillColorNineBox(index: Int) {
  return NINE_BOX_COLORS[index % NINE_BOX_COLORS.length];
}
